import gql from 'graphql-tag';
import createClient from '../../clientSetup';

export const MONEY_MARKET_FUND = gql`
  query BYOPAllocation($tickers: [String!]!) {
    mutualFunds(tickers: $tickers) {
      name: shortName
      price {
        asOfDate
        price
        priceChange
      }
      netAssets
      netAssetsAsOfDate
      ticker
      trpCode
      cusip
      retirement
      targetYear
      iClass
      recordKeepingCode
      grossExpenseRatio
      morningStarRatings {
        asOfDate
        morningStarCategoryName
        morningStarOverallRating
        morningStarOverallQuantity
      }
      assetAllocationGroupedRankings {
        name
        percentTotalNetAssets
        asOfDate
      }
      twelveMonthLowPrice {
        price
      }
      twelveMonthHighPrice {
        price
      }
    }
  }
`;

export const US_TREASURY_MM_TICKER = 'PRTXX';
export const US_TREASURY_ICLASS_MM_TICKER = 'TRGXX';

export const getMoneyMarketFunds = async () => {
  const client = createClient();

  const {
    data: { mutualFunds }
  } = await client.query({
    query: MONEY_MARKET_FUND,
    variables: {
      tickers: [US_TREASURY_MM_TICKER, US_TREASURY_ICLASS_MM_TICKER]
    }
  });
  return mutualFunds;
};

export const MONEY_MARKET_MOCK_DATA = [
  {
    request: {
      query: MONEY_MARKET_FUND
    },
    result: {
      data: {
        mutualFunds: {
          name: 'U.S. Treasury Money Fund',
          price: {
            asOfDate: '2021-04-18T04:00:00Z',
            price: 1,
            priceChange: 0,
            __typename: 'PriceDetail'
          },
          netAssets: null,
          netAssetsAsOfDate: null,
          ticker: 'PRTXX',
          trpCode: 'UST',
          cusip: '77957T305',
          retirement: false,
          targetYear: 0,
          iClass: false,
          recordKeepingCode: '53',
          grossExpenseRatio: 0.28,
          morningStarRatings: {
            asOfDate: null,
            morningStarCategoryName: null,
            morningStarOverallRating: 0,
            morningStarOverallQuantity: 0
          },
          assetAllocationGroupedRankings: [],
          twelveMonthLowPrice: {
            price: 1,
            __typename: 'YTDPrice'
          },
          twelveMonthHighPrice: {
            price: 1,
            __typename: 'YTDPrice'
          },
          __typename: 'GraphQLMutualFund'
        }
      }
    }
  }
];
